module.exports = __webpack_public_path__ + "img/photo-0005.0a620cde.jpg";